import React from 'react';
import { Card } from 'react-bootstrap';
import {formatTimestampInMs} from "../commons/utils";

const TradeHistoryCard = ({ trades }) => {
  return (
    <Card>
      <Card.Body>
        <Card.Title>Trade History</Card.Title>
        <table className="table table-striped">
          <thead>
          <tr>
            <th>Symbol</th>
            <th>Direction</th>
            <th>Profit Rate</th>
            <th>Open Timestamp</th>
            <th>Close Timestamp</th>
          </tr>
          </thead>
          <tbody>
          {trades.map((trade, index) => (
            <tr key={index}>
              <td>{trade.symbol}</td>
              <td>{trade.direction}</td>
              <td>{trade.profitRate}</td>
              <td>{trade.openTimestamp} - {formatTimestampInMs(trade.openTimestamp)}</td>
              <td>{trade.closeTimestamp} - {formatTimestampInMs(trade.closeTimestamp)}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </Card.Body>
    </Card>
  );
};

export default TradeHistoryCard;
